// Capitali e nomi italiani delle nazioni rappresentate nel dataset
// degli articoli. Chiavi: ISO 3166-1 alpha-2.
//
// CAPITALS è usato dalla mappa per disegnare il puntino "respiro"
// sopra la capitale dei Paesi menzionati nel dispaccio.
// COUNTRY_NAME_IT è usato per la tooltip al hover sulla nazione.

import type { Coord } from "./countryCoords";

export const CAPITALS: Record<string, Coord> = {
  IT: [41.9, 12.5],     // Roma
  FR: [48.85, 2.35],    // Parigi
  DE: [52.52, 13.4],    // Berlino
  ES: [40.42, -3.7],    // Madrid
  PT: [38.72, -9.14],   // Lisbona
  GB: [51.51, -0.13],   // Londra
  IE: [53.35, -6.26],   // Dublino
  NL: [52.37, 4.9],     // Amsterdam
  BE: [50.85, 4.35],    // Bruxelles
  LU: [49.61, 6.13],    // Lussemburgo
  AT: [48.21, 16.37],   // Vienna
  CH: [46.95, 7.45],    // Berna
  PL: [52.23, 21.01],   // Varsavia
  CZ: [50.08, 14.43],   // Praga
  SK: [48.15, 17.11],   // Bratislava
  HU: [47.5, 19.04],    // Budapest
  RO: [44.43, 26.1],    // Bucarest
  BG: [42.7, 23.32],    // Sofia
  GR: [37.98, 23.73],   // Atene
  TR: [39.93, 32.86],   // Ankara
  CY: [35.18, 33.36],   // Nicosia
  MT: [35.9, 14.51],    // La Valletta
  HR: [45.82, 16.0],    // Zagabria
  SI: [46.05, 14.5],    // Lubiana
  RS: [44.79, 20.46],   // Belgrado
  BA: [43.86, 18.41],   // Sarajevo
  AL: [41.33, 19.82],   // Tirana
  MK: [42.0, 21.43],    // Skopje
  ME: [42.44, 19.26],   // Podgorica
  XK: [42.67, 21.17],   // Pristina
  DK: [55.68, 12.57],   // Copenaghen
  SE: [59.33, 18.07],   // Stoccolma
  NO: [59.91, 10.75],   // Oslo
  FI: [60.17, 24.94],   // Helsinki
  EE: [59.44, 24.75],   // Tallinn
  LV: [56.95, 24.11],   // Riga
  LT: [54.69, 25.28],   // Vilnius
  BY: [53.9, 27.57],    // Minsk
  UA: [50.45, 30.52],   // Kiev
  RU: [55.75, 37.62],   // Mosca
  KZ: [51.16, 71.43],   // Astana
  AZ: [40.41, 49.87],   // Baku
  US: [38.9, -77.04],   // Washington
  CA: [45.42, -75.7],   // Ottawa
  MX: [19.43, -99.13],  // Città del Messico
  PA: [8.98, -79.52],   // Panama
  BR: [-15.79, -47.88], // Brasilia
  AR: [-34.6, -58.38],  // Buenos Aires
  CN: [39.9, 116.41],   // Pechino
  JP: [35.68, 139.69],  // Tokyo
  KR: [37.57, 126.98],  // Seoul
  IN: [28.61, 77.21],   // Nuova Delhi
  PK: [33.69, 73.05],   // Islamabad
  BD: [23.81, 90.41],   // Dacca
  AF: [34.53, 69.17],   // Kabul
  IR: [35.69, 51.39],   // Teheran
  IQ: [33.31, 44.37],   // Baghdad
  IL: [31.78, 35.21],   // Gerusalemme
  PS: [31.95, 35.23],   // Ramallah
  SY: [33.51, 36.29],   // Damasco
  LB: [33.89, 35.5],    // Beirut
  JO: [31.95, 35.93],   // Amman
  SA: [24.71, 46.67],   // Riyadh
  AE: [24.45, 54.38],   // Abu Dhabi
  QA: [25.28, 51.53],   // Doha
  KW: [29.37, 47.98],   // Kuwait City
  OM: [23.59, 58.55],   // Mascate
  YE: [15.35, 44.21],   // Sana'a
  LY: [32.89, 13.18],   // Tripoli
  EG: [30.04, 31.24],   // Il Cairo
  DZ: [36.75, 3.06],    // Algeri
  TN: [36.81, 10.18],   // Tunisi
  MA: [34.02, -6.83],   // Rabat
  SD: [15.59, 32.53],   // Khartoum
  ET: [9.03, 38.74],    // Addis Abeba
  KE: [-1.29, 36.82],   // Nairobi
  NG: [9.08, 7.49],     // Abuja
  CI: [6.83, -5.28],    // Yamoussoukro
  ZA: [-25.74, 28.19],  // Pretoria
  VN: [21.03, 105.85],  // Hanoi
  SG: [1.35, 103.82],   // Singapore
  ID: [-6.21, 106.85],  // Giacarta
  TH: [13.76, 100.5],   // Bangkok
  PH: [14.6, 120.98],   // Manila
  MY: [3.14, 101.69],   // Kuala Lumpur
  AU: [-35.28, 149.13], // Canberra
  NZ: [-41.29, 174.78], // Wellington
};

export const COUNTRY_NAME_IT: Record<string, string> = {
  IT: "Italia",
  FR: "Francia",
  DE: "Germania",
  ES: "Spagna",
  PT: "Portogallo",
  GB: "Regno Unito",
  IE: "Irlanda",
  NL: "Paesi Bassi",
  BE: "Belgio",
  LU: "Lussemburgo",
  AT: "Austria",
  CH: "Svizzera",
  PL: "Polonia",
  CZ: "Repubblica Ceca",
  SK: "Slovacchia",
  HU: "Ungheria",
  RO: "Romania",
  BG: "Bulgaria",
  GR: "Grecia",
  TR: "Turchia",
  CY: "Cipro",
  MT: "Malta",
  HR: "Croazia",
  SI: "Slovenia",
  RS: "Serbia",
  BA: "Bosnia ed Erzegovina",
  AL: "Albania",
  MK: "Macedonia del Nord",
  ME: "Montenegro",
  XK: "Kosovo",
  DK: "Danimarca",
  SE: "Svezia",
  NO: "Norvegia",
  FI: "Finlandia",
  EE: "Estonia",
  LV: "Lettonia",
  LT: "Lituania",
  BY: "Bielorussia",
  UA: "Ucraina",
  RU: "Russia",
  KZ: "Kazakhstan",
  AZ: "Azerbaigian",
  US: "Stati Uniti d'America",
  CA: "Canada",
  MX: "Messico",
  PA: "Panama",
  BR: "Brasile",
  AR: "Argentina",
  CN: "Cina",
  JP: "Giappone",
  KR: "Corea del Sud",
  IN: "India",
  PK: "Pakistan",
  BD: "Bangladesh",
  AF: "Afghanistan",
  IR: "Iran",
  IQ: "Iraq",
  IL: "Israele",
  PS: "Palestina",
  SY: "Siria",
  LB: "Libano",
  JO: "Giordania",
  SA: "Arabia Saudita",
  AE: "Emirati Arabi Uniti",
  QA: "Qatar",
  KW: "Kuwait",
  OM: "Oman",
  YE: "Yemen",
  LY: "Libia",
  EG: "Egitto",
  DZ: "Algeria",
  TN: "Tunisia",
  MA: "Marocco",
  SD: "Sudan",
  ET: "Etiopia",
  KE: "Kenya",
  NG: "Nigeria",
  CI: "Costa d'Avorio",
  ZA: "Sudafrica",
  VN: "Vietnam",
  SG: "Singapore",
  ID: "Indonesia",
  TH: "Thailandia",
  PH: "Filippine",
  MY: "Malesia",
  AU: "Australia",
  NZ: "Nuova Zelanda",
};
